import React from 'react';
import { Button, Form } from '@themesberg/react-bootstrap';

export default function PoPaymentTermSelect({ id, formik, terms, savedValue = '' }) {
  const invalid = Boolean(formik.touched.payment_term && formik.errors.payment_term);
  const savedTermMissing = savedValue && !terms.data.some(term => term.name === savedValue);
  return (
    <Form.Group className="mb-3" controlId={id}>
      <Form.Label>Payment Term <span className="text-danger">*</span></Form.Label>
      <Form.Select id={id} {...formik.getFieldProps('payment_term')}
        disabled={formik.isSubmitting || terms.loading || Boolean(terms.error)}
        isInvalid={invalid} aria-describedby={id + '-help'}>
        <option value="">{terms.loading ? 'Loading payment terms...' : 'Select Payment Term'}</option>
        {savedTermMissing && <option value={savedValue} disabled>{savedValue} (saved term)</option>}
        {terms.data.map(term => <option key={term.id} value={term.name}>{term.name}</option>)}
      </Form.Select>
      <Form.Control.Feedback type="invalid">{formik.errors.payment_term}</Form.Control.Feedback>
      <div id={id + '-help'} className="small mt-1">
        {terms.error ? <div role="alert" className="text-danger">{terms.error}</div>
          : !terms.loading && terms.data.length === 0
            ? <div className="text-muted">No payment terms are available. Create one in Payment Terms.</div>
            : null}
        {!terms.loading && savedTermMissing && <div className="text-muted">The saved term is no longer in Payment Terms. You can keep it or choose an available term.</div>}
        <Button type="button" variant="link" size="sm" className="p-0"
          disabled={formik.isSubmitting || terms.loading} onClick={terms.refresh}>
          {terms.error ? 'Retry payment terms' : 'Refresh payment terms'}
        </Button>
      </div>
    </Form.Group>
  );
}
